import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyStateGetAccessCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/get-access';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import styled from 'styled-components';
import { EmptyStateExampleCompanyProfilesCTA } from './ctas/empty-state-example-company-profiles-cta';

export function EmptyStateNoDataAccess() {
  return (
    <EmptyInfoBox title="Get access" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <Text>To access this data set, you need an Upright subscription.</Text>
        <EmptyStateGetAccessCTA />
        <EmptyStateExampleCompanyProfilesCTA />
      </>
    </EmptyInfoBox>
  );
}

const Text = styled.div``;
